<button class="tile">
  <span class="icon" [ngClass]="account.icon" role="img" aria-label="Risk Icon"></span>
  <ds-billing-status-pill
    [statusText]="account.status.statusText"
    [amount]="account.amount | currencyUSD"
  ></ds-billing-status-pill>
</button>
